import React from 'react';
import CartClientPage from '../components/cart/CartClientPage';

export default function CartPage() {
  return (
    <div className="min-h-full bg-gradient-to-br from-gray-50 to-gray-100">
      <CartClientPage />
    </div>
  );
}
